<template>
  <div class="classic-case">
    <div class="section-title">
      <div class="title">解决方案</div>
    </div>
    <div class="solutions">
      <div class="solution-menu">
        <div
          class="menu-item"
          :class="{ active: activeIndex === 0 }"
          @click="setActive(0)"
        >
          <img
            src="@/assets/first/dynamicEnvironmentalMonitoring.svg"
            alt="动环监控"
            class="menu-icon"
          />
          <span>动环监控</span>
        </div>
        <div
          class="menu-item"
          :class="{ active: activeIndex === 1 }"
          @click="setActive(1)"
        >
          <img
            src="@/assets/first/DCOM.svg"
            alt="基础设施运维"
            class="menu-icon"
          />
          <span>基础设施运维</span>
        </div>
        <div
          class="menu-item"
          :class="{ active: activeIndex === 2 }"
          @click="setActive(2)"
        >
          <img
            src="@/assets/first/IO.svg"
            alt="基础设施运营"
            class="menu-icon"
          />
          <span>基础设施运营</span>
        </div>
        <div
          class="menu-item"
          :class="{ active: activeIndex === 3 }"
          @click="setActive(3)"
        >
          <img
            src="@/assets/first/DPI.svg"
            alt="数字电厂巡检"
            class="menu-icon"
          />
          <span>数字电厂巡检</span>
        </div>
        <div
          class="menu-item"
          :class="{ active: activeIndex === 4 }"
          @click="setActive(4)"
        >
          <img
            src="@/assets/first/HCPI.svg"
            alt="危化行业巡检"
            class="menu-icon"
          />
          <span>危化行业巡检</span>
        </div>
        <div
          class="menu-item"
          :class="{ active: activeIndex === 5 }"
          @click="setActive(5)"
        >
          <img
            src="@/assets/first/EMS.svg"
            alt="光伏、储能 EMS"
            class="menu-icon"
          />
          <span>光伏、储能 EMS</span>
        </div>
      </div>
      <div class="solution-content">
        <div class="content-header">
          <!-- 左右分布 -->
          <div style="display: flex; justify-content: space-between">
            <div>
              <h3>
                <span class="number-title">{{
                  solutions[activeIndex].title.split(" ")[0]
                }}</span>
                <span class="main-title">{{
                  solutions[activeIndex].title.split(" ")[1]
                }}</span>
              </h3>
            </div>
            <div
              class="text-title"
              style="display: flex; align-items: center"
              @click="goToScheme(solutions[activeIndex].key)"
            >
              查看更多 >
            </div>
          </div>
          <div class="title-underline"></div>
          <div class="header-underline">
            <div class="header-left">
              <p>{{ solutions[activeIndex].desc }}</p>
            </div>
            <div class="header-right">
              <img
                v-if="solutions[activeIndex].img"
                :src="solutions[activeIndex].img"
                alt="solution-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassicCase",
  data() {
    return {
      activeIndex: 0,
      solutions: [
        {
          title: "01 动环监控系统DCMS",
          desc: "通过整合动力配电、制冷环境、安防消防的设备及子系统，实现基础设施监控对象全覆盖，准确采集运行数据，精准定位故障根源。",
          img: require("@/assets/first/dcms-dashboard.svg"),
          key: "environmentalMonitoring",
        },
        {
          title: "02 基础设施运维",
          desc: "在DCMS基础上实现精细化能效展示与分析，对空间、电力、制冷、承重多维度容量精细化监测，辅助IT资产部署与容量扩容决策。",
          img: require("@/assets/first/infrastructureOperationAndMaintenance.svg"),
          key: "dataCenterInfrastructure",
        },
        {
          title: "03 基础设施运营",
          desc: "结合数据中心的运维特点，参考Uptime M&O 体系，以CMDB(配置管理数据库)为核心，帮助客户构建业务完整、流程规范的运维服务管理体系，实现数据中心日常运维工作的电子化、规范化、流程化、自动化。",
          img: require("@/assets/first/infrastructureOperation.svg"),
          key: "dataCenterOperations",
        },
        {
          key: "digitalPowerPlant",
          title: "04 数字电厂巡检",
          desc: "通过将高新技术与电厂安全生产、运行监管等业务深度融合，从现实电厂获取运行数据，在虚拟电厂中进行仿真、分析和优化，解决信息共享、生产方式、经营管理等核心问题，达到降本增效、节能减排等目标，最终实现电厂数字化转型。",
          img: require("@/assets/first/digitalPowerPlantInspection.svg"),
        },
        {
          title: "05 危化行业巡检",
          key: "chemicalIndustry",
          desc: "应用机器人、视频监控、AI算法等技术，实现危化环境的自动化智能巡检，确保巡检频次，及时获取巡检信息，降低人工成本，提高巡检安全性和效率。",
          img: require("@/assets/first/hazardousIndustryInspection.svg"),
        },
        {
          title: "06 光伏、储能 EMS",
          key: "energyManagement",
          desc: "光伏储能管理系统是智能监控和优化管理平台，通过实时监测、发电预测、储能控制、平衡管理等算法，实现对光伏发电和储能系统的高效协调，最大化系统发电量和经济效益。EMS提升光伏储能的效率、稳定性与安全性，是光伏储能系统的核心控制大脑。",
          img: require("@/assets/first/photovoltaicStorageEMS.svg"),
        },
      ],
    };
  },
  methods: {
    setActive(idx) {
      this.activeIndex = idx;
    },
    goToScheme(key) {
      localStorage.setItem("home_active_tab", "scheme");
      this.$router.push({ path: "/home/scheme", query: { key } });
    },
  },
};
</script>

<style lang="less" scoped>
.classic-case {
  width: 100%;
  max-width: 1430px;
  // margin: 0 auto;
  // margin-left: 156px;
  //上下左
  padding: 60px 0 60px 100px;
  .section-title {
    text-align: left;
    margin-bottom: 40px;
    .title {
      width: 144px;
      height: 36px;
      font-size: 36px;
      font-family: Microsoft YaHei, Microsoft YaHei-700;
      font-weight: 700;
      text-align: LEFT;
      color: #2c3239;
      line-height: 36px;
    }
  }

  .solutions {
    display: flex;
  }

  .solution-menu {
    width: 240px;
    border-right: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 30px;

    .menu-item {
      width: 260px;
      height: 72px;
      border: 1px solid #dce0e5;
      border-radius: 8px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 20px;
      margin: 0;
      cursor: pointer;
      transition: all 0.3s;
      box-sizing: border-box;
      font-size: 18px;

      .menu-icon {
        width: 24px;
        height: 24px;
        margin-right: 8px;
        filter: brightness(0) saturate(100%) invert(50%) sepia(0%) saturate(0%)
          hue-rotate(0deg) brightness(90%) contrast(90%);
        transition: all 0.3s;
      }
    }
    .menu-item.active {
      width: 272px;
      height: 84px;
      border: 1px solid #fff;
      border-radius: 8px;
      background: url("~@/assets/first/selectBackground.png") no-repeat
        center/cover;
      z-index: 1;

      .menu-icon {
        filter: brightness(0) saturate(100%) invert(40%) sepia(100%)
          saturate(1000%) hue-rotate(200deg) brightness(100%) contrast(100%);
      }
    }
  }

  .solution-content {
    flex: 1;
    padding: 30px;

    .content-header {
      margin-bottom: 30px;

      h3 {
        display: flex;
        align-items: center;
        font-size: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei-700;
        font-weight: 700;
        color: #2c3239;
        line-height: 36px;
        margin-bottom: 0;
        letter-spacing: 1px;
      }

      .number-title {
        position: relative;
        margin-right: 10px;
        font-size: 24px;
        color: #2c3239;
        font-weight: 700;
        display: inline-block;
      }

      .number-title::after {
        content: "";
        display: block;
        width: 26px;
        height: 3px;
        background: #222;
        position: absolute;
        left: 0;
        bottom: -11px;
        border-radius: 2px;
      }

      .main-title {
        font-size: 24px;
        font-weight: 700;
        color: #2c3239;
      }
      .text-title {
        font-size: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei-400;
        font-weight: 400;
        text-align: RIGHT;
        color: #a5abb1;
        letter-spacing: 0.09px;
        cursor: pointer;
      }
      .title-underline {
        width: 100%;
        height: 3px;
        background: #e9ecf1;
        margin: 8px 0 18px 0;
        border-radius: 2px;
      }

      .header-underline {
        width: 100%;
        height: auto;
        background: none;
        margin: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .header-left {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        max-width: 100%;
        min-width: auto;
        margin-left: 0;
        padding: 32px 0;
      }
      .header-left p {
        width: 100%;
        height: auto;
        font-size: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei-400;
        font-weight: 400;
        text-align: left;
        color: #5f656c;
        line-height: 32px;
        letter-spacing: 0.09px;
      }
      .header-right {
        width: 100%;
        margin-left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .header-right img {
        width: 100%;
        max-width: 1000px;
        height: auto;
        border-radius: 8px;
        object-fit: cover;
      }
    }
  }
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
</style>
